package com.schoolconnect.app.feature.timetable

import com.schoolconnect.app.feature.attendance.ParentAttendanceChild

data class ParentTimeTableScheduleRow(
    val day: String,
    val subjects: List<String> = emptyList(),
    val holiday: String? = null
)

data class ParentTimeTableGridUi(
    val times: List<String> = emptyList(),
    val rows: List<ParentTimeTableScheduleRow> = emptyList()
)

data class ParentTimeTableUiState(
    val children: List<ParentAttendanceChild> = emptyList(),
    val selectedChildIndex: Int = 0,
    val weekly: ParentTimeTableGridUi = ParentTimeTableGridUi(),
    val special: ParentTimeTableGridUi = ParentTimeTableGridUi(),
    val specialScheduleLabel: String? = null,
    val classLabel: String? = null,
    val weekLabel: String? = null,
    val isLoading: Boolean = false,
    val errorMessage: String? = null
) {
    val selectedChild: ParentAttendanceChild? get() = children.getOrNull(selectedChildIndex)
}

sealed interface ParentTimeTableUiEvent {
    data class ChildSelected(val index: Int) : ParentTimeTableUiEvent
    data object Retry : ParentTimeTableUiEvent
}
